import TemplateDetailPage from '@/views/templates/TemplateDetailPage'

export default function Page() {
  return <TemplateDetailPage />
}
